module.exports = __webpack_public_path__ + "img/icon-pharmacy.26b9c9e2.svg";